module.exports = __webpack_public_path__ + "static/media/CBM-Seminario_Latinoamerica.4a65ef9b.pdf";